import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useGetCohortQuery, useRenameCohortMutation } from '@verantos-dev/data-access-cohorts';

import { useCohortModalContext } from '../context/modalContext';

export const useRenameCohortModal = () => {
  const { itemId, closeDialog } = useCohortModalContext();
  const { projectId } = useParams<{ projectId: string }>();
  const [name, setName] = useState('');

  const [renameMutation, { isLoading, error }] = useRenameCohortMutation();
  const { data, isLoading: loadingCohort } = useGetCohortQuery(
    { cohortId: itemId || '', projectId: projectId || '' },
    {
      skip: !itemId || !projectId,
    }
  );

  useEffect(() => {
    if (data?.data?.cohortName) {
      setName(data.data.cohortName);
    }
  }, [data?.data?.cohortName]);

  const isRenamed = data?.data?.cohortName !== name.trim();

  const onChangeName = (_: string, value: string) => {
    setName(value);
  };

  const onSubmit = async () => {
    if (projectId && itemId) {
      await renameMutation({
        projectId: projectId,
        cohortId: itemId,
        data: { cohortName: name.trim() },
      });
    }
  };

  const isValidForSubmit = !loadingCohort && !isLoading && Boolean(name.trim()) && isRenamed;

  return {
    name,
    onChangeName,
    isSubmitting: isLoading,
    renameCohortError: error,
    isInitialLoading: loadingCohort,
    isValidForSubmit,
    cohort: data?.data,
    onClose: closeDialog,
    onSubmit,
  };
};
